(() => {
  const root = document.documentElement;
  const cartLayer = document.querySelector("[data-cart-layer]");
  const cartContent = document.querySelector("[data-cart-content]");
  const cartFooter = document.querySelector("[data-cart-footer]");
  const cartDrawer = document.querySelector(".cart-drawer");
  const toast = document.querySelector("[data-toast]");
  let toastTimer;

  const escapeHtml = (value = "") =>
    String(value).replace(/[&<>"']/g, (character) => {
      const entities = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" };
      return entities[character];
    });

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || "EGP";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency,
        maximumFractionDigits: currency === "EGP" ? 0 : 2,
      }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  const setExpanded = (element, value) => {
    if (element) element.setAttribute("aria-expanded", String(value));
  };

  const closeMobileMenu = () => {
    const menu = document.querySelector("[data-mobile-menu]");
    const toggle = document.querySelector("[data-menu-toggle]");
    if (!menu) return;
    menu.hidden = true;
    setExpanded(toggle, false);
    root.classList.remove("is-menu-open");
  };

  document.querySelector("[data-menu-toggle]")?.addEventListener("click", (event) => {
    const menu = document.querySelector("[data-mobile-menu]");
    if (!menu) return;
    menu.hidden = false;
    setExpanded(event.currentTarget, true);
    root.classList.add("is-menu-open");
  });

  document.querySelector("[data-menu-close]")?.addEventListener("click", closeMobileMenu);

  const openCart = () => {
    if (!cartLayer) return;
    cartLayer.hidden = false;
    root.classList.add("is-cart-open");
    cartLayer.querySelector(".cart-drawer")?.focus();
  };

  const closeCart = () => {
    if (!cartLayer) return;
    cartLayer.hidden = true;
    root.classList.remove("is-cart-open");
  };

  document.querySelectorAll("[data-cart-open]").forEach((button) => button.addEventListener("click", openCart));
  document.querySelectorAll("[data-cart-close]").forEach((button) => button.addEventListener("click", closeCart));

  const bindCartLineActions = () => {
    if (!cartContent) return;
    cartContent.querySelectorAll("[data-cart-remove]").forEach((button) => {
      button.addEventListener("click", async () => {
        button.disabled = true;
        await changeCartLine(Number(button.dataset.cartRemove), 0);
      });
    });
    cartContent.querySelectorAll("[data-cart-quantity]").forEach((button) => {
      button.addEventListener("click", async () => {
        const control = button.closest("[data-line]");
        if (!control) return;
        button.disabled = true;
        await changeCartLine(Number(control.dataset.line), Math.max(0, Number(button.dataset.cartQuantity)));
      });
    });
  };

  const changeCartLine = async (line, quantity) => {
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
    if (!response.ok) throw new Error("Unable to update cart");
    const cart = await response.json();
    renderCart(cart);
  };

  const renderCart = (cart) => {
    document.querySelectorAll("[data-cart-count]").forEach((element) => {
      element.textContent = String(cart.item_count);
    });

    if (!cartContent || !cartFooter) return;
    if (!cart.items.length) {
      const emptyTitle = escapeHtml(cartDrawer?.dataset.emptyTitle || "");
      const emptyText = escapeHtml(cartDrawer?.dataset.emptyText || "");
      const emptyButton = escapeHtml(cartDrawer?.dataset.emptyButton || "");
      const emptyUrl = escapeHtml(cartDrawer?.dataset.emptyUrl || window.Shopify.routes.root);
      cartContent.innerHTML = `<div class="cart-drawer__empty"><h3>${emptyTitle}</h3><p>${emptyText}</p><a class="button button--dark" href="${emptyUrl}">${emptyButton}</a></div>`;
      cartFooter.hidden = true;
      return;
    }

    cartContent.innerHTML = cart.items
      .map(
        (item, index) => `
          <article class="cart-drawer__line">
            <a class="cart-drawer__image" href="${escapeHtml(item.url)}">
              ${item.image ? `<img src="${escapeHtml(item.image)}&width=240" alt="${escapeHtml(item.product_title)}" width="120" height="150">` : ""}
            </a>
            <div class="cart-drawer__item-copy">
              <a class="cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
              ${item.variant_title ? `<span>${escapeHtml(item.variant_title)}</span>` : ""}
              <strong>${formatMoney(item.final_line_price)}</strong>
              <div class="cart-drawer__item-actions">
                <div class="quantity-control" data-line="${index + 1}"><button type="button" aria-label="${escapeHtml(cartDrawer?.dataset.decreaseLabel || "")}" data-cart-quantity="${Math.max(0, item.quantity - 1)}">−</button><span>${item.quantity}</span><button type="button" aria-label="${escapeHtml(cartDrawer?.dataset.increaseLabel || "")}" data-cart-quantity="${item.quantity + 1}">+</button></div>
                <button class="text-link" type="button" data-cart-remove="${index + 1}">${escapeHtml(cartDrawer?.dataset.removeLabel || "")}</button>
              </div>
            </div>
          </article>`,
      )
      .join("");
    cartFooter.hidden = false;
    document.querySelectorAll("[data-cart-total]").forEach((element) => { element.textContent = formatMoney(cart.total_price); });
    bindCartLineActions();
  };

  bindCartLineActions();

  const refreshCart = async () => {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("Unable to load cart");
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  document.querySelectorAll("[data-ajax-cart-form]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error("Unable to add product");
        await refreshCart();
        const notice = document.querySelector("[data-cart-notice]");
        if (notice && cartDrawer?.dataset.addedMessage) {
          notice.textContent = cartDrawer.dataset.addedMessage;
          notice.hidden = false;
        }
        openCart();
        if (toast) {
          toast.classList.add("is-visible");
          clearTimeout(toastTimer);
          toastTimer = setTimeout(() => toast.classList.remove("is-visible"), 1800);
        }
      } catch (error) {
        form.submit();
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  });

  document.querySelectorAll("[data-product-root]").forEach((productRoot) => {
    productRoot.querySelectorAll("[data-media-target]").forEach((thumbnail) => {
      thumbnail.addEventListener("click", () => {
        productRoot.querySelectorAll("[data-media-target]").forEach((item) => item.classList.remove("is-active"));
        productRoot.querySelectorAll("[data-product-media]").forEach((media) => {
          media.hidden = true;
          media.classList.remove("is-active");
        });
        const target = productRoot.querySelector(`#${CSS.escape(thumbnail.dataset.mediaTarget)}`);
        if (target) {
          target.hidden = false;
          target.classList.add("is-active");
          thumbnail.classList.add("is-active");
        }
      });
    });

    const quantity = productRoot.querySelector('input[name="quantity"]');
    productRoot.querySelector("[data-quantity-minus]")?.addEventListener("click", () => {
      if (quantity) quantity.value = String(Math.max(Number(quantity.min || 1), Number(quantity.value || 1) - 1));
    });
    productRoot.querySelector("[data-quantity-plus]")?.addEventListener("click", () => {
      if (quantity) quantity.value = String(Number(quantity.value || 1) + 1);
    });

    const productSection = productRoot.closest(".shopify-section") || productRoot.parentElement;
    const stickyBar = productSection?.querySelector("[data-mobile-purchase-bar]");
    const stickyButton = stickyBar?.querySelector("[data-sticky-product-add]");
    const primaryButton = productRoot.querySelector("[data-add-button]");
    const mobileViewport = window.matchMedia("(max-width: 780px)");

    stickyButton?.addEventListener("click", () => primaryButton?.click());

    if (stickyBar && primaryButton && "IntersectionObserver" in window) {
      let primaryButtonIsVisible = true;
      const updateStickyBar = () => {
        const shouldShow = mobileViewport.matches && !primaryButtonIsVisible;
        stickyBar.classList.toggle("is-visible", shouldShow);
        stickyBar.setAttribute("aria-hidden", String(!shouldShow));
      };
      const observer = new IntersectionObserver(([entry]) => {
        primaryButtonIsVisible = entry.isIntersecting;
        updateStickyBar();
      }, { threshold: 0.15 });
      observer.observe(primaryButton);
      mobileViewport.addEventListener?.("change", updateStickyBar);
    }
  });

  document.querySelectorAll("[data-product-filter]").forEach((section) => {
    section.querySelectorAll("[data-filter-button]").forEach((button) => {
      button.addEventListener("click", () => {
        section.querySelectorAll("[data-filter-button]").forEach((item) => item.classList.remove("is-active"));
        button.classList.add("is-active");
        const filter = button.dataset.filterButton;
        section.querySelectorAll("[data-filter-item]").forEach((item) => {
          const groups = String(item.dataset.filterItem || "").split(/\s+/);
          item.hidden = filter !== "all" && !groups.includes(filter);
        });
      });
    });
  });

  document.querySelectorAll("[data-cart-page-form]").forEach((form) => {
    form.querySelectorAll("[data-page-quantity-minus], [data-page-quantity-plus]").forEach((button) => {
      button.addEventListener("click", () => {
        const control = button.closest(".quantity-control");
        const input = control?.querySelector('input[name="updates[]"]');
        if (!input) return;
        const delta = button.hasAttribute("data-page-quantity-plus") ? 1 : -1;
        input.value = String(Math.max(0, Number(input.value || 0) + delta));
      });
    });
  });

  document.querySelectorAll("[data-product-root]").forEach((productRoot) => {
    const variantDataNode = productRoot.parentElement?.querySelector("[data-product-variants]");
    const select = productRoot.querySelector("[data-variant-select]");
    const price = productRoot.querySelector("[data-product-price]");
    const addButton = productRoot.querySelector("[data-add-button]");
    const productSection = productRoot.closest(".shopify-section") || productRoot.parentElement;
    const stickyPrice = productSection?.querySelector("[data-sticky-product-price]");
    const stickyAddButton = productSection?.querySelector("[data-sticky-product-add]");
    if (!variantDataNode || !select) return;

    let variants = [];
    try {
      variants = JSON.parse(variantDataNode.textContent);
    } catch (error) {
      return;
    }

    productRoot.querySelectorAll("[data-option-position]").forEach((input) => {
      input.addEventListener("change", () => {
        const selectedOptions = Array.from(productRoot.querySelectorAll("[data-option-position]:checked")).map((item) => item.value);
        const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selectedOptions[index]));
        if (!variant) return;
        select.value = String(variant.id);
        const selectedOption = select.querySelector(`option[value="${variant.id}"]`);
        if (price && selectedOption?.dataset.price) price.textContent = selectedOption.dataset.price;
        if (stickyPrice && selectedOption?.dataset.price) stickyPrice.textContent = selectedOption.dataset.price;
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? addButton.dataset.availableLabel : addButton.dataset.soldLabel;
        }
        if (stickyAddButton) {
          stickyAddButton.disabled = !variant.available;
          stickyAddButton.textContent = variant.available ? stickyAddButton.dataset.availableLabel : stickyAddButton.dataset.soldLabel;
        }
        const inventoryNote = productRoot.querySelector("[data-inventory-note]");
        if (inventoryNote) inventoryNote.hidden = !variant.available;
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);
      });
    });
  });

  document.querySelectorAll("[data-mobile-cart-checkout]").forEach((stickyBar) => {
    const cartSection = stickyBar.closest(".shopify-section") || stickyBar.parentElement;
    const primaryCheckout = cartSection?.querySelector("[data-cart-primary-checkout]");
    const mobileViewport = window.matchMedia("(max-width: 780px)");
    if (!primaryCheckout || !("IntersectionObserver" in window)) return;

    let primaryCheckoutIsVisible = true;
    const updateStickyBar = () => {
      const shouldShow = mobileViewport.matches && !primaryCheckoutIsVisible;
      stickyBar.classList.toggle("is-visible", shouldShow);
      stickyBar.setAttribute("aria-hidden", String(!shouldShow));
    };
    const observer = new IntersectionObserver(([entry]) => {
      primaryCheckoutIsVisible = entry.isIntersecting;
      updateStickyBar();
    }, { threshold: 0.15 });
    observer.observe(primaryCheckout);
    mobileViewport.addEventListener?.("change", updateStickyBar);
  });

  const filterPanel = document.querySelector("[data-filter-panel]");
  const filterToggle = document.querySelector("[data-filter-toggle]");
  const closeFilters = () => {
    if (!filterPanel) return;
    filterPanel.hidden = true;
    setExpanded(filterToggle, false);
  };
  filterToggle?.addEventListener("click", () => {
    if (!filterPanel) return;
    filterPanel.hidden = false;
    setExpanded(filterToggle, true);
    filterPanel.querySelector("button, input, select, a")?.focus();
  });
  document.querySelector("[data-filter-close]")?.addEventListener("click", closeFilters);

  document.querySelectorAll("[data-scent-finder]").forEach((finder) => {
    const results = finder.querySelector("[data-finder-results]");
    const cards = Array.from(finder.querySelectorAll("[data-finder-card]"));
    const submit = finder.querySelector("[data-finder-submit]");
    const reset = finder.querySelector("[data-finder-reset]");

    submit?.addEventListener("click", () => {
      const audience = finder.querySelector('input[name="finder-audience"]:checked')?.value || "all";
      const moment = finder.querySelector('input[name="finder-moment"]:checked')?.value || "everyday";
      const intensity = finder.querySelector('input[name="finder-intensity"]:checked')?.value || "balanced";

      cards
        .map((card, index) => {
          let score = 0;
          if (audience === "all" || card.dataset.audience === "all" || card.dataset.audience === audience) score += 3;
          if (card.dataset.moment === moment) score += 2;
          if (card.dataset.intensity === intensity) score += 1;
          return { card, score, index };
        })
        .sort((a, b) => b.score - a.score || a.index - b.index)
        .forEach(({ card }, index) => {
          card.hidden = index >= 3;
          card.style.order = String(index);
        });

      if (results) {
        results.hidden = false;
        results.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });

    reset?.addEventListener("click", () => {
      if (results) results.hidden = true;
      finder.querySelector('input[name="finder-audience"][value="all"]')?.click();
      finder.querySelector('input[name="finder-moment"][value="everyday"]')?.click();
      finder.querySelector('input[name="finder-intensity"][value="balanced"]')?.click();
      finder.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeCart();
      closeMobileMenu();
      closeFilters();
    }
  });
})();
